import { Box, IconButton, InputAdornment } from "@mui/material";
import { forwardRef, useImperativeHandle } from "react";
import { useForm } from "react-hook-form";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import FormInputText from "../components/Form/FormInputText";
import { generatePassword } from "../lib/helper";

interface ResetPasswordFormValues {
  password: string;
}

export default forwardRef((_props, ref: any) => {
  const { handleSubmit, control, setValue, setError } = useForm<ResetPasswordFormValues>({
    defaultValues: { password: generatePassword() },
  });

  useImperativeHandle(ref, () => ({
    onSubmit(): Promise<ResetPasswordFormValues> {
      return new Promise((resolve, reject) => {
        handleSubmit((v) => resolve(v), reject)();
      });
    },
  }));

  return (
    <Box
      component="form"
      sx={{ "& .MuiTextField-root": { mt: 1, mb: 1 } }}
      autoComplete="off"
    >
      <FormInputText
        name="password"
        control={control}
        setError={setError}
        label="New Password"
        required
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="regenerate password"
                edge="end"
                onClick={() => setValue("password", generatePassword())}
              >
                <AutorenewIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        rules={{
          required: "Password is required",
          maxLength: {
            value: 30,
            message: "Password must be less than 30 characters",
          },
          minLength: {
            value: 6,
            message: "Password must be at least 6 characters",
          },
        }}
      />
    </Box>
  );
});
